module.exports = __webpack_public_path__ + "static/L2_content_user_input_3_eg-c2896c7829637601202e54459dbf465b.png";